import { mixed, object, string } from "yup";
import {
  PriceMoneyResource,
  priceMoneyResourceSchema,
} from "./PriceMoneyResource";

export enum PriceIntervalUnit {
  Month = "month",
  Year = "year",
  Day = "day",
}

export enum BillingType {
  OneTime = "one_time",
  Recurring = "recurring",
}

export interface PriceResource {
  uuid: string;
  intervalUnit: PriceIntervalUnit | null;
  billingType: BillingType;
  money: PriceMoneyResource;
}

export const priceResourceSchema = object({
  uuid: string().required(),
  intervalUnit: mixed<PriceIntervalUnit>()
    .oneOf(Object.values(PriceIntervalUnit) as PriceIntervalUnit[])
    .nullable()
    .default(null),
  billingType: mixed<BillingType>()
    .oneOf(Object.values(BillingType) as BillingType[])
    .required(),
  money: priceMoneyResourceSchema.required(),
});
